import { useDispatch } from "react-redux";

import {
    findAppsUpdateExpandedFilter,
    findAppsUpdateFilters,
} from "app/pages/sales-intelligence/store/find-apps/action-creators";
import type { AppsSourceType } from "app/pages/sales-intelligence/store/find-apps/types/appsSourceType";

interface IResult<T> {
    handleFilterUpdate: (filters: Partial<T>) => void;
    handleExpandFilter: (f: string | null) => void;
}

function useUpdateTabState<T>(tabName: AppsSourceType): IResult<T> {
    const dispatch = useDispatch();

    const handleFilterUpdate = (filters: Partial<T>) => {
        dispatch(findAppsUpdateFilters([tabName, filters]));
    };

    const handleExpandFilter = (filterName: string | null) => {
        dispatch(findAppsUpdateExpandedFilter([tabName, filterName]));
    };

    return {
        handleFilterUpdate,
        handleExpandFilter,
    };
}

export default useUpdateTabState;
